import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import PropTypes from "prop-types";
import { OG_IMAGE_TYPES, OGImage } from "../og-image";

const ScrapCarsMetaTags = ({
    metaTitle,
    metaDescription,
    ogTitle = "",
    ogDescription = ""
}) => {
    const baseUrl = `${appUrl()}/scrap-cars/ `;

    return (
        <React.Fragment>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="title" content={metaTitle} />
                <meta name="description" content={metaDescription} />
                <meta name="ROBOTS" content="INDEX,FOLLOW" />
                <meta property="og:title" content={ogTitle} />
                <meta property="og:description" content={ogDescription} />
                <meta property="og:url" content={`${appUrl()}/`} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Cars24" />
                <link href={`${baseUrl}`} rel="canonical" />
            </Helmet>
            <OGImage type={OG_IMAGE_TYPES.scrap} />
        </React.Fragment>
    );
};

ScrapCarsMetaTags.propTypes = {
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    ogTitle: PropTypes.string,
    ogDescription: PropTypes.string
};

export default ScrapCarsMetaTags;
